<template>
  <div class="zhaopin-zhiwei">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/zhaopin/zhiwei3"
      @before-fetch="beforeFetch"
    >
      <el-table-column slot="zhiwei_name" label="职位名" class-name="pointer" width="140">
        <template v-slot="{row}">
          <div @click="jobInfo(row)">
            <span>{{row.zhiwei_name}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column slot="bumen" show-overflow-tooltip label="部门">
        <template v-slot="{row}">
          <span>{{row | bumen}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="jianli" label="简历数">
        <template v-slot="{row}">
          <el-button
            type="text"
            @click="$router.push({
              path: `/resume`,
              query:{
                id:row.zhiwei_id,
                active:$route.query.active
              }
            })"
          >{{row.$zhiwei_jianlis}}份简历</el-button>
        </template>
      </el-table-column>
      <el-table-column slot="caozuo" label="操作" fixed="right" width="100">
        <template v-slot="{row}">
          <el-button type="text" @click.native="jobInfo(row)">岗位描述</el-button>
        </template>
      </el-table-column>
    </c-table>
    <edit v-model="model"></edit>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import DepartmentCascade from '@/components/service/department-cascade'
import Edit from './#zhiwei-edit'
import mixin from '@/mixins'

export default {
  name: 'zhaopin-xiaxianzhiwei',
  mixins: [ mixin ],
  components: { CTable, Edit },
  data () {
    return {
      fields: [
        {
          prop: 'department',
          placeholder: '部门',
          component: DepartmentCascade,
          value: []
        }
      ],
      columns: [
        { slot: 'zhiwei_name' },
        { slot: 'bumen' },
        { prop: 'zhiwei_jibie', label: '级别', width: 100 },
        { prop: 'zhiwei_number', label: '人数', width: 80 },
        { slot: 'jianli' },
        { slot: 'shangchuan' },
        { slot: 'caozuo' }
      ],
      model: null
    }
  },
  methods: {
    beforeFetch (params) {
      [ (params.jiagou_first), (params.jiagou_second), (params.jiagou_third), (params.jiagou_forth) ] = params.department
      delete params.department
    }
  }
}
</script>

<style lang="scss">
</style>
